
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 0C.89 0 0 .89 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9h-2v7H2V2h7V0H2zm12.78 1a.69.69 0 00-.48.2l-1.22 1.21 2.5 2.5L16.8 3.7c.26-.26.26-.7 0-.95L15.25 1.2c-.13-.13-.3-.2-.47-.2zm-2.41 2.12L5 10.5V13h2.5l7.37-7.38-2.5-2.5z","fill":"#6D6D6D"}})])
          )
        }
      }
    